import React from 'react';
import {
  findCompetitorTrNameByPosition,
  getTranslatedEventName
} from '../../../utils/event';
import {
  getInternalLinks,
  IInternalLinks
} from '../../../utils/internal-links';
import {
  EventPositions,
  EventTypes,
  IEventCompetitor
} from '../../../utils/types';

interface IProps {
  className?: string
  tournamentName?: string
  separator?: string
  eventCompetitors?: IEventCompetitor[]
}

const EventBannerTitle: React.FC<IProps> = (props) => {
  const {
    className = undefined,
    tournamentName,
    eventCompetitors,
    separator
  } = props;

  const [internalLinks] = React.useState<IInternalLinks|null>(getInternalLinks())

  return (
    <>
      {tournamentName && (
        <h2 className={className}>{tournamentName}</h2>
      )}
      {eventCompetitors && (
        <h2 className={className}>
          {internalLinks && internalLinks.awayCompetitorPageLink &&
          internalLinks.homeCompetitorPageLink
          && EventTypes.event_1v1 // Only for Events with 2 competitors
            ? (
              <>
                <a href={internalLinks.homeCompetitorPageLink}>
                  {findCompetitorTrNameByPosition(eventCompetitors, EventPositions.home)}
                </a>
                {separator}
                <a href={internalLinks.awayCompetitorPageLink}>
                  {findCompetitorTrNameByPosition(eventCompetitors, EventPositions.away)}
                </a>
              </>
            ) : (
              <>
                {getTranslatedEventName(eventCompetitors, separator)}
              </>
            )
          }
        </h2>
      )}
    </>
  )
}

export default EventBannerTitle;
